
import ContactUs from "../component/Contact-us/ContactUs";
import MainTitle from "../component/sharedComponents/MainTittle";



const ContactUsPage = () => {
  return (
    <main className="bg-custom-gradient-bg">

      <section className="px-4 max-container xl:px-0">
        {/* <MainTitle
          title="Contact Us –"
          subdescription="Lets Talk"
          description="We’re here to help your business grow."
        /> */}
        <ContactUs
          phonesTel="+201029999210"
          phonesMob="+201205599333"
          email="info@workbrand.org"
          address="72 Arab League Street, Dokki, Dokki District, Giza Governorate 12411"
        />
      </section>

    </main>
  );
};

export default ContactUsPage;
